import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography, Box, CircularProgress, Alert, Button } from '@mui/material';

const EmailVerificationPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');

      if (!token) {
        setIsLoading(false);
        setErrorMessage('Token de verificação não encontrado no URL.');
        return;
      }

      try {
        const baseUrl = process.env.REACT_APP_HOST && process.env.REACT_APP_PORT
            ? `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}/api/`
              : 'http://localhost:3000/api/';

        const response = await fetch(`${baseUrl}account/verify-email?token=${token}`);
        
        if (response.ok) {
          setIsLoading(false);
          setIsSuccess(true);
        } else {
          const errorData = await response.json();
          setIsLoading(false);
          setErrorMessage(errorData.message || 'Erro na verificação. O token pode ser inválido ou ter expirado.');
        }
      } catch (error) {
        setIsLoading(false);
        setErrorMessage('Erro ao se conectar com o servidor. Tente novamente mais tarde.');
        console.error('Erro de verificação:', error);
      }
    };

    verifyEmail();
  }, [location]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', textAlign: 'center' }}>
        <CircularProgress sx={{ mb: 2 }} />
        <Typography variant="h5">Verificando seu e-mail...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', textAlign: 'center' }}>
      {isSuccess ? (
        <>
          <Typography variant="h5" color="success" gutterBottom>
            E-mail verificado com sucesso!
          </Typography>
          <Typography variant="body1">
            Sua conta está ativa. Você já pode fazer login.
          </Typography>
          <Button variant="contained" sx={{ mt: 3 }} onClick={() => navigate('/login')}>
            Ir para o Login
          </Button>
        </>
      ) : (
        <>
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
          <Button variant="outlined" onClick={() => navigate('/login')}>
            Voltar para o Login
          </Button>
        </>
      )}
    </Box>
  );
};

export default EmailVerificationPage;